import { render, staticRenderFns } from "./credits_detail_credits_view.vue?vue&type=template&id=654959a9&scoped=true&"
import script from "./credits_detail_credits_view.vue?vue&type=script&lang=js&"
export * from "./credits_detail_credits_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654959a9",
  null
  
)

export default component.exports